import styled from 'styled-components';
import { MaxWidth } from '../../common/base';

const HeroWrapper = styled.div`
  padding: 144px 0;
  position: relative;
  height: 720px;
  white-space: pre-wrap;
  h1 {
    font-size: 60px;
    ${MaxWidth.md`
      font-size: 36px;
    `}
  }
  p {
    font-size: 18px;
    margin: 30px 0;
  }
  ${MaxWidth.lg`
    padding: 80px 0;
  `}
  ${MaxWidth.md`
    padding: 64px 0;
    height: auto;
  `}
`;

const HeroImg = styled.div`
  position: absolute;
  top: -80px;
  right: 0;
  height: 100%;
  z-index: -1;
  ${MaxWidth.md`
    position: relative;
    top: 0;
  `}

  img {
    ${MaxWidth.lg`
      width: 760px;
    `}
    ${MaxWidth.md`
      width: calc(100% - 16px);
      position: relative;
      right: -16px;
    `}
  }
`;

export { HeroWrapper, HeroImg };
